import './article-media-img.scss';

/**
 * version    1.0
 * class      <type> (ArticleMediaImg)
 * classdesc
 */
export class ArticleMediaImg {}
